import CookieHelper from "../helpers/cookie-helper";

/**
 * NavbarDisplay class
 */
class NavbarDisplay {

    /**
     * Show navbar as user is logged in.
     * 
     * @params user: User
     * @params repsonse: any
     * @returns void
     */
    showLogedIn(user, response) {
        
        if (user.isLogggedIn()) {
            $('.logged-in').show();
            $('.logged-out').hide();
            $('.welcome-username').html(CookieHelper.get('uName'));
            $('.credit-balance').html(response.Data.AuthUserResponse[0]['Credit']);
            $('.currency-balance').html(response.Data.AuthUserResponse[0]['Currency']);
        }
    }

    /**
     * Updates credit balance
     * 
     * @params user: User
     * @params repsonse: any
     * @returns void
     */
    showUpdatedCredit(user, response) {
    
        if (user.isLogggedIn()) {
            $('.logged-in').show();
            $('.logged-out').hide();
            $('.welcome-username').html(user.username);
            $('.credit-balance').html(response.Credit);
            $('.currency-balance').html(CookieHelper.get('currency'));
        }
    }

    /**
     * Show navbar as user is logged out.
     */
    showLogedOut() {
        $('.logged-in').hide();
        $('.logged-out').show();
        $('.welcome-username').empty();
        $('.credit-balance').empty();
        $('.currency-balance').empty();
    }

}

export default NavbarDisplay;



//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/js/navbar/navbar-display.js
// module id = 136
// module chunks = 13